exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._19uL7{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:auto;font-weight:400}._2CPzg{margin-bottom:20px}.iIGMt{margin:auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:red;font-size:20px;line-height:24px;font-weight:700;margin-bottom:3px;text-align:center}@media screen and (max-width:768px){._2CPzg{margin-bottom:5px;margin-top:5px}}", ""]);

// exports
exports.locals = {
	"root": "_19uL7",
	"indentDown": "_2CPzg",
	"title": "iIGMt"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/IrrelevantMessage/IrrelevantMessage.css
// module id = 2754
// module chunks = 32 36